import options from './role-users.component';

export default {
    selector: 'dtRoleUsers',
    options
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/roles/role-users/index.js